import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import './styles.scss';
import classNames from 'classnames';

interface IPageHeaderProps {
  title: string;
  onClickBack?: () => void;
  isBold?: boolean;
  isNoTopMargin?: boolean;
  isNoBottomMargin?: boolean;
}

const PageHeader: React.FC<IPageHeaderProps> = ({ title, onClickBack, isBold }) => {
  return (
    <div className="page-header">
      {onClickBack && (
        <IconButton className="page-header__back-button" onClick={onClickBack}>
          <KeyboardBackspaceIcon />
        </IconButton>
      )}

      <h1 className={classNames('page-header__title', { 'page-header__title--bold': isBold })}>{title}</h1>
    </div>
  );
};

export default PageHeader;
